import React from 'react';
import PropTypes from 'prop-types';

const WhatsAppButton = ({ make, model, branchName, stockReference }) => {
  const whatsAppUrl = () => {
    const textParam = encodeURIComponent(
      branchName
        ? `I'd like to chat about this ${make} ${model} at ${branchName}.\n \nhttps://www.arnoldclark.com/vehicles/ref/${stockReference}`
        : `I'd like to chat about this ${make} ${model}.\n \nhttps://www.arnoldclark.com/vehicles/ref/${stockReference}`,
    );
    return `https://api.whatsapp.com/send?phone=+447774688488&text=${textParam}`;
  };

  return (
    <a
      className="ch-btn ch-width--12 productheader__contact-whatsapp"
      data-event-name="Product page: Whatsapp CTA"
      data-gtm-track="click_cta"
      data-gtm-track-label="Contact Panel WhatsApp CTA"
      data-insight-event="conversion"
      href={whatsAppUrl()}
    >
      WhatsApp
    </a>
  );
};

WhatsAppButton.propTypes = {
  branchName: PropTypes.string,
  make: PropTypes.string,
  model: PropTypes.string,
  stockReference: PropTypes.string,
};

export default WhatsAppButton;
